import { render, staticRenderFns } from "./PlaylistsEdit.vue?vue&type=template&id=34631ec8&scoped=true&"
import script from "./PlaylistsEdit.vue?vue&type=script&lang=js&"
export * from "./PlaylistsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34631ec8",
  null
  
)

export default component.exports